export const dataHooks = {
    numberInputTicker: 'number-input-ticker',
};
//# sourceMappingURL=constants.js.map